import React, { useContext } from "react";

export interface IProductTileBadgeConfiguration {
  disableEventBadge?: boolean;
}

const DEFAULT_CONFIGURATION = {};

export const ConfigurationContext =
  React.createContext<IProductTileBadgeConfiguration>(DEFAULT_CONFIGURATION);

export interface IProductTileBadgeConfigurationProp {
  configuration: IProductTileBadgeConfiguration;
}

type withoutConfiguration<Props> = Omit<
  Props,
  keyof IProductTileBadgeConfigurationProp
>;

export const withConfigurationConsumer = <
  Props extends IProductTileBadgeConfigurationProp
>(
  Component: React.ComponentType<Props>
): React.ComponentType<
  Omit<Props, keyof IProductTileBadgeConfigurationProp>
> => {
  return function (props: withoutConfiguration<Props>) {
    const configuration = useContext(ConfigurationContext);
    const composedProps = {
      ...props,
      configuration,
    } as Props;
    return <Component {...composedProps} />;
  };
};
